import SubHeader from "../../components/header/SubHeader";
import React, {useEffect, useRef, useState} from "react";
import SelectOption from "../../components/common/form/SelectOption";
import {useDispatch, useSelector} from "react-redux";
import {createInitialData, createPdfData, fetchInvoiceById, updateInvoice} from "../../store/manual-pdf-slice";
import ManualInvoice from "../../components/htmlToPdf/ManualInvoice";
import {GetAllSetting} from "../../store/setting-slice";
import {fetchAllBanks} from "../../store/bank-setting-slice";
import {useParams} from "react-router-dom";
import moment from "moment-timezone";
import Button from "../../components/common/button/Button";
import {getValidatedLimit} from "../../components/Utility";
import {GSTType, PaymentStatus} from "../../enums/enums";
import {fetchCustomers} from "../../store/customer-slice";
import Stack from "../../components/ui/Stack";

const timezone = 'Asia/Kolkata';
const CreateInvoice = () => {
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const params = useParams();
    const [pdfEdit, setPdfEdit] = useState(null);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [isSelectFromList, setIsSelectFromList] = useState(false);
    const {pagination} = useSelector(state => state.manualPdf);
    const [customerInput, setCustomerInput] = useState('');
    const [userNotFoundError, setUserNotFoundError] = useState(null);
    const {limit, currentPage} = getValidatedLimit(pagination);
    const {gstNumber, GSTINError, enableDisable, fetchAllSettingStatus} = useSelector(state => state.setting);
    const {items: allBanksDetails} = useSelector(state => state.bankSetting);
    const {
        error,
        items: AllInvoice,
        createStatus,
        updateStatus,
        finalData: invoice
    } = useSelector(state => state.manualPdf);

    const bankList = allBanksDetails.reduce((acc, bank) => {
        acc[bank.accountNumber] = bank.name;
        return acc;
    }, {});

    const PaymentStatusWithoutFailed = Object.freeze(
        Object.fromEntries(
            Object.entries(PaymentStatus).filter(([key]) => key !== "Failed")
        )
    );

    const {
        items: suggestions,
        fetchStatus: fetchCustomersStatus,
    } = useSelector(state => state.customer);

    useEffect(() => {
        dispatch(fetchCustomers({...userRole}));
    }, [dispatch, userRole]);

    const initialFormData = {
        id: userRole.scopeId,
        invoiceNo: "",
        gstNumber: fetchAllSettingStatus === 'success' ? gstNumber : '',
        customerId: '',
        customerDetails: {
            fName: "",
            lName: "",
            phone: undefined,
            address: undefined,
            gstNumber: undefined,
        },
        items: [],
        bank: '',
        bankInfo: {},
        totals: {
            subtotal: "",
            discount: "",
            advancePaid: "",
            total: "",
            remainingTotal: "",
        },
        gstInfo: {
            GST: '',
            SGST: '',
            CGST: ''
        },
        enableDisable: enableDisable || {},
        startDate: "",
        endDate: "",
        status: PaymentStatusWithoutFailed.Pending,
    };

    const [formData, setFormData] = useState(initialFormData);

    // Form errors
    const [errors, setErrors] = useState({
        startDate: '',
        'customerDetails.gstNumber': '',
        'customerDetails.fName': '',
        'customerDetails.phone': '',
    });

    const [productsToBilled, setProductsToBilled] = useState([{
        name: '',
        sacCode: '',
        quantity: '',
        unitPrice: '',
        gst: '',
        gstPrice: '',
        total: ''
    }]);

    //Product errors
    const [productErrors, setProductErrors] = useState([
        {name: '', gst: '', sacCode: '', quantity: '', unitPrice: ''}
    ]);

    const subtotal = productsToBilled.reduce(
        (sum, item) => sum + (parseFloat(item.total) || 0),
        0
    );

    const discount = parseFloat(formData.totals.discount) || 0;
    const advance = parseFloat(formData.totals.advancePaid) || 0;
    const total = Math.max(subtotal - discount, 0);
    const remainingTotal = Math.max(subtotal - (discount + advance), 0);

    const validateField = (id, value) => {
        let error = "";


        // Trim string values
        const trimmedValue = typeof value === "string" ? value.trim() : value;

        // Skip validation if selected from list
        if (isSelectFromList) {
            // Remove phone and first name error if exists
            if (id === "customerDetails.phone" || id === "customerDetails.fName") {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [id]: "",
                }));
            }
            return true;
        }

        switch (id) {
            case "startDate":
                if (!trimmedValue) {
                    error = "Start date is required";
                }
                break;

            case "customerDetails.gstNumber":
                if (trimmedValue) {
                    // GST format: 2 digits + 5 letters + 4 digits + 1 letter + 1 alphanumeric + Z + 1 alphanumeric
                    const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
                    if (!gstPattern.test(trimmedValue)) {
                        error = "Invalid GST number";
                    }
                }
                break;

                case "customerDetails.phone":
                    if (!trimmedValue) {
                        error = "Phone number is required";
                    } else if (
                        !/^(?:\+91[-\s]?|91[-\s]?|0)?[1-9]\d{9}$/.test(trimmedValue)
                    ) {
                        error = "Please enter a valid Indian phone number (e.g. 9876543210, +919876543210, 01722001234)";
                    }
                    break;

            case "customerDetails.fName":
                if (!trimmedValue) {
                    error = "First name is required";
                }
                break;

            // Add more cases for other fields if needed
            default:
                break;
        }

        // Update the errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: error,
        }));

        // Return whether the field is valid
        return error === "";
    };

    const validateProductRow = (product, index) => {
        const errors = {};

        // Validate Name
        if (!product.name || product.name.trim() === '') {
            errors.name = 'Name is required';
        }

        // Validate GST only if gstPrint is enabled
        if (formData.enableDisable.gstPrint) {
            if (!product.gst && product.gst !== 0) {
                errors.gst = 'GST is required';
            }
        }

        //validate SAC only if SAC is enabled
        if (formData.enableDisable.sacCode) {
            if (product.sacCode === '' || isNaN(Number(product.sacCode))) {
                errors.sacCode = 'SAC code is required and must be a number';
            }
        }

        //validate quantity
        if (product.quantity === '' || isNaN(Number(product.quantity))) {
            errors.quantity = 'Quantity is required and must be a number';
        }

        //validate unit price
        if (product.unitPrice === '' || isNaN(Number(product.unitPrice))) {
            errors.unitPrice = 'Unit price is required and must be a number';
        }

        setProductErrors(prev => {
            const newErrors = [...prev];
            newErrors[index] = errors;
            return newErrors;
        });

        return Object.keys(errors).length === 0;
    };

    const handleSelectCustomer = () => {
        setIsSelectFromList(false);
        setFormData({
            ...formData,
            customerId: '',
            customerDetails: {
                fName: '',
                lName: '',
                phone: undefined,
                gstNumber: undefined,
                address: undefined
            }
        });
        setCustomerInput('');
        setUserNotFoundError(null);
    }

    const validateAllProducts = () => {
        return productsToBilled.map((product, index) =>
            validateProductRow(product, index)
        ).every(valid => valid);
    };

    const handleProductBlur = (index, field) => {
        const product = productsToBilled[index];
        validateProductRow(product, index);
    };

    const validateForm = () => {
        let isValid = true;

        // Flatten fields you want to validate
        const fieldsToValidate = {
            startDate: formData.startDate,
            "customerDetails.gstNumber": formData.customerDetails.gstNumber,
            "customerDetails.fName": formData.customerDetails.fName,
            "customerDetails.phone": formData.customerDetails.phone,
        };

        Object.entries(fieldsToValidate).forEach(([key, value]) => {
            const valid = validateField(key, value);
            if (!valid) isValid = false;
        });

        return isValid;
    };

    const handleBlur = (e) => {
        const {id, value} = e.target;
        validateField(id, value);
    };

    // Works for nested state updates too
    const handleFormChange = (e) => {
        const {name, value} = e.target;

        // Handle nested keys like "customerDetails.name"
        if (name.includes(".")) {
            const [parent, child] = name.split(".");
            setFormData((prev) => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value,
                },
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };


    const handleProductChange = (index, field, value) => {
        setProductsToBilled(prev => {
            const updated = [...prev];
            const item = {...updated[index]};

            // Update numeric fields
            if (field === "quantity") {
                // Allow only numeric values (including empty string)
                if (/^\d*$/.test(value)) {
                    item.quantity = value === "" ? "" : Number(value);
                }
            } else if (field === "unitPrice") {
                // Allow only numeric values (including empty string)
                if (/^\d*$/.test(value)) {
                    item.unitPrice = value === "" ? "" : Number(value);
                }
            } else if (field === "gst") {
                // Ensure GST is numeric
                item.gst = value === "" ? 0 : Number(value);
            } else {
                item[field] = value;
            }

            // Calculate subtotal
            const qtyNum = Number(item.quantity) || 0;
            const unitPriceNum = Number(item.unitPrice) || 0;
            const subtotal = qtyNum * unitPriceNum;

            // Calculate GST amount
            const gstPercent = Number(item.gst) || 0;
            const gstAmount = (subtotal * gstPercent) / 100;

            // Calculate total
            const total = subtotal + gstAmount;

            // Store calculated values rounded to 2 decimals
            item.gstPrice = Number(gstAmount.toFixed(2));
            item.total = Number(total.toFixed(2));

            updated[index] = item;
            return updated;
        });
    };


    const handleAddRow = () => {
        setProductsToBilled(prev => [...prev, {
            name: '',
            sacCode: '',
            quantity: '',
            unitPrice: '',
            gst: '',
            total: ''
        }]);
        setProductErrors(prev => [...prev, {name: '', sacCode: '', gst: '', quantity: '', unitPrice: ''}]);
    };

    const handleRemoveRow = (index) => {
        setProductsToBilled(prev => prev.filter((_, i) => i !== index));
        setProductErrors(prev => prev.filter((_, i) => i !== index));
    };

    const onResetHandler = () => {
        setFormData(initialFormData);
        setProductsToBilled([{name: '', sacCode: '', quantity: '', unitPrice: '', gst: '', total: ''}]);
        setProductErrors([{name: "", sacCode: '', gst: "", quantity: '', unitPrice: ''}]);
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        const isFormValid = validateForm();
        const areProductsValid = validateAllProducts();

        if (!isFormValid || !areProductsValid) return;
        // Transform items for API submission
        const transformedItems = productsToBilled.map(item => {
            // Find the GST key string from GSTType for the numeric value
            const gstKey = Object.keys(GSTType).find(key => GSTType[key] === item.gst) || "Gst-0%";

            return {
                name: item.name,
                sacCode: Number(item.sacCode),
                quantity: Number(item.quantity),
                unitPrice: Number(item.unitPrice),
                gst: gstKey,
                gstPrice: Number(item.gstPrice),
                total: Number(item.total) || 0
            };
        });

        // Calculate GST totals
        const gstTotal = transformedItems.reduce((sum, item) => sum + item.gstPrice, 0);
        const sgst = gstTotal / 2;
        const cgst = gstTotal / 2;

        const bankDetails = allBanksDetails.find(item => item.accountNumber === Number(formData.bank));
        const updatedData = {
            ...formData,
            bankInfo: bankDetails,
            items: transformedItems,
            gstInfo: {
                GST: gstTotal,
                SGST: sgst,
                CGST: cgst
            },
            enableDisable: {
                ...enableDisable
            },
            totals: {
                subtotal: subtotal,
                advancePaid: advance,
                discount: discount,
                total: total,
                remainingTotal: remainingTotal,
            },
            customerId: isSelectFromList ? formData.customerId : undefined,
        }

        dispatch(createInitialData(updatedData));

        if (pdfEdit) {
            // Remove unwanted keys without mutating the original object
            const {id, _id, branch, bank, customer, customerDetails, ...dataToUpdate} = updatedData;

            dispatch(updateInvoice({
                ...userRole,
                id: params.invoiceId,
                data: dataToUpdate
            }))
        } else {
            dispatch(createPdfData({
                data: updatedData,
                ...userRole
            }));
        }
    };

    useEffect(() => {
        if (params.invoiceId) {
            dispatch(fetchInvoiceById({...userRole, id: params.invoiceId}));
        }
    }, [dispatch, params.invoiceId, userRole]);

    //Want to remove productsToBilled from the dependency array i.e creating this ref
    const itemsRef = useRef(productsToBilled);
    useEffect(() => {
        if (params.invoiceId && AllInvoice.length > 0) {
            const found = AllInvoice.find(item => item.id === params.invoiceId);
            if (found) {
                setPdfEdit(found);

                // Pre-fill form data
                setFormData(prev => ({
                    ...prev,
                    ...found,
                    bank: found.bankInfo?.accountNumber || "",
                    startDate: found.startDate ? moment(found.startDate).tz(timezone).format('YYYY-MM-DD') : '',
                    endDate: found.endDate ? moment(found.endDate).tz(timezone).format('YYYY-MM-DD') : '',
                    enableDisable: found.enableDisable || {},
                    customerDetails: found.customer
                }));

                // Create a reverse map from value → label
                const gstValueFromLabel = (label) => {
                    return GSTType[label] ?? 0; // returns 0 if label not found
                };

                // Prefill products
                setProductsToBilled(
                    found.items && found.items.length > 0
                        ? found.items.map(item => ({
                            ...item,
                            gst: gstValueFromLabel(item.gst),
                        }))
                        : itemsRef.current // fallback if no items
                );
            }
        }
    }, [params.invoiceId, AllInvoice]);

    useEffect(() => {
        if (fetchAllSettingStatus === 'success') {
            setFormData(prev => ({
                ...prev,
                gstNumber: gstNumber || '',
                enableDisable: pdfEdit
                    ? prev.enableDisable       // keep existing when editing
                    : (enableDisable || {})    // use global when creating
            }));
        }
    }, [fetchAllSettingStatus, gstNumber, enableDisable, pdfEdit]);

    useEffect(() => {
        if (allBanksDetails.length > 0) {
            setFormData(prev => ({
                ...prev,
                // only set default if bank is empty
                bank: prev.bank || allBanksDetails.find(b => b.primary)?.accountNumber || allBanksDetails[0]?.accountNumber || ""
            }));
        }
    }, [allBanksDetails]);

    useEffect(() => {
        dispatch(fetchAllBanks({...userRole}));
        dispatch(GetAllSetting({...userRole}))
    }, [dispatch, userRole])

    return (
        <>
            <SubHeader
                title={
                    createStatus === "success"
                        ? "Download Invoice"
                        : pdfEdit
                            ? "Update Invoice"
                            : "Create Invoice"
                }
            >
                {pdfEdit && updateStatus !== "success" ? (
                    <Button
                        to={`../../?page=${currentPage}&limit=${limit}`}
                        className="bg-secondary bg-opacity-50"
                    >
                        Back
                    </Button>
                ) : !pdfEdit && createStatus !== "success" ? (
                    <Button
                        to="/invoice"
                        className="bg-secondary bg-opacity-50"
                    >
                        Back
                    </Button>
                ) : null}
            </SubHeader>

            {/*GSTIN Number*/}
            {!(createStatus === 'success' || updateStatus === "success") &&
                <p className="mb-0 text-end">GSTIN No - <span
                    className="text-secondary fw-semibold">{gstNumber || 'No GSTIN number available'}</span></p>}

            {(createStatus === 'success' || updateStatus === "success") &&
                <div className="position-relative end-0">
                    {pdfEdit ? <ManualInvoice invoice={invoice} pdfEdit={pdfEdit} pagination={{limit, currentPage}}/> :
                        <ManualInvoice invoice={invoice}/>}
                </div>
            }

            {(GSTINError || error) && <p className="fs-md text-danger m-0">{GSTINError || error}</p>}
            {!(createStatus === 'success' || updateStatus === "success") && <div className="container m-0 p-0">
                <form onSubmit={handleSubmit}>
                    {/*CreateInvoice date & gstNumber*/}
                    <div className="row mb-2">
                        <div className="col-md-12">
                            <div className="row">
                                {/* Date Section */}
                                <div className="col-12">
                                    <h5>Invoice Dates</h5>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Start Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="startDate"
                                        name="startDate"
                                        onBlur={handleBlur}
                                        value={formData.startDate}
                                        onChange={handleFormChange}
                                    />
                                    {errors.startDate &&
                                        <div className="invalid-feedback d-block">{errors.startDate}</div>}
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">End Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="endDate"
                                        value={formData.endDate}
                                        onChange={handleFormChange}
                                    />
                                </div>
                                {formData.enableDisable.bankPrint &&
                                    <div className="col-md-3">
                                        <label className="form-label">Select Bank</label>
                                        <SelectOption
                                            className="form-select"
                                            name="bank"
                                            id="bank"
                                            value={formData.bank}
                                            options={bankList}
                                            onBlur={handleBlur}
                                            onChange={handleFormChange}
                                        />
                                    </div>
                                }
                                <div className="col-md-3">
                                    <label className="form-label">Status</label>
                                    <SelectOption
                                        className="form-select"
                                        name="status"
                                        id="status"
                                        enums={true}
                                        value={formData.status}
                                        options={PaymentStatusWithoutFailed}
                                        onBlur={handleBlur}
                                        onChange={handleFormChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>


                    <Stack className="justify-content-between align-items-center">
                        <h5 className="mt-3">Customer Details</h5>
                        {!pdfEdit && <Button className="btn-sm bg-primary bg-opacity-50"
                                             onClick={handleSelectCustomer}>Select customer</Button>}
                    </Stack>
                    {/*Customer details*/}
                    <div className="row">
                        <p className={`invalid-feedback mb-1 ${userNotFoundError ? "d-block" : "d-none"}`}>
                            <span className="text-secondary fw-semibold">Note:</span> {userNotFoundError}
                        </p>
                        {!isSelectFromList && userNotFoundError == null && !pdfEdit && (
                            <div className="col-3 mb-3">
                                <div className="position-relative">
                                    <label className="form-label">Select customer</label>
                                    <input
                                        className="form-control"
                                        name="phone"
                                        type="text"
                                        value={customerInput}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setCustomerInput(value);
                                            setFormData({
                                                ...formData, customerId: value, customerDetails: {
                                                    fName: '',
                                                    lName: '',
                                                    phone: undefined,
                                                    gstNumber: undefined,
                                                    address: undefined
                                                }
                                            });
                                            setIsSelectFromList(false);

                                            // Show all if input is empty
                                            const filtered = value.trim() === ''
                                                ? suggestions
                                                : suggestions.filter(s =>
                                                    (`${s.fName ?? ''} - ${s.phone}`)
                                                        .toLowerCase()
                                                        .includes(value.toLowerCase())
                                                );

                                            setFilteredSuggestions(filtered);
                                            setShowSuggestions(true);
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => setShowSuggestions(false), 100); // delay to allow click
                                            if (!isSelectFromList && customerInput !== '') {
                                                setUserNotFoundError("Customer doesn’t exist. Enter details manually.")
                                            }
                                        }}
                                        onFocus={() => {
                                            // Show all suggestions when input is focused
                                            setFilteredSuggestions(suggestions);
                                            setShowSuggestions(true);
                                        }}
                                        autoComplete="off"
                                    />

                                    {/* Suggestion Dropdown */}
                                    {fetchCustomersStatus && showSuggestions && filteredSuggestions.length > 0 && (
                                        <ul className="custom-menu position-absolute w-100 z-3 bg-white shadow-lg"
                                            style={{maxHeight: "200px", overflowY: "auto", top: '70px'}}>
                                            {filteredSuggestions.map((item, index) => {
                                                const label = `${[item.fName, item.lName].filter(Boolean).join(' ')}${item.phone ? ' - ' + item.phone : ''}`;
                                                return (
                                                    <li
                                                        key={index}
                                                        className="list fs-sm px-2"
                                                        onMouseDown={() => {
                                                            setCustomerInput(`${item.fName} ${item.lName}`);
                                                            setFormData({
                                                                ...formData,
                                                                customerId: item._id,
                                                                customerDetails: {
                                                                    fName: item?.fName,
                                                                    lName: item?.lName,
                                                                    phone: item?.phone ?? undefined,
                                                                    gstNumber: item?.gstNumber ?? undefined,
                                                                    address: item?.address?.address ?? undefined
                                                                }
                                                            });
                                                            setIsSelectFromList(true);
                                                            setShowSuggestions(false);
                                                            setUserNotFoundError(null);
                                                        }}>
                                                        {label}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/*show this row in case of edit*/}
                    {(pdfEdit || !(isSelectFromList === false && userNotFoundError == null)) && (
                        <div className="row gy-3">
                            {/*First Name*/}
                            <div className="col-md-3">
                                <label className="form-label">First Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="customerDetails.fName"
                                    id="customerDetails.fName"
                                    value={formData.customerDetails.fName}
                                    onBlur={handleBlur}
                                    onChange={handleFormChange}
                                    disabled={isSelectFromList || pdfEdit}
                                />
                                {errors["customerDetails.fName"] && (
                                    <div className="invalid-feedback d-block">{errors["customerDetails.fName"]}</div>
                                )}
                            </div>

                            {/*Last Name*/}
                            <div className="col-md-3">
                                <label className="form-label">Last Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="customerDetails.lName"
                                    id="customerDetails.lName"
                                    value={formData.customerDetails.lName}
                                    onBlur={handleBlur}
                                    onChange={handleFormChange}
                                    disabled={isSelectFromList || pdfEdit}
                                />
                            </div>

                            {/*Phone*/}
                            <div className="col-md-3">
                                <label className="form-label">Customer Phone</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="customerDetails.phone"
                                    name="customerDetails.phone"
                                    onBlur={handleBlur}
                                    value={formData.customerDetails.phone}
                                    onChange={handleFormChange}
                                    disabled={isSelectFromList || pdfEdit}
                                />
                                {errors["customerDetails.phone"] && (
                                    <div className="invalid-feedback d-block">{errors["customerDetails.phone"]}</div>
                                )}
                            </div>

                            {/*Customer Gst*/}
                            <div className="col-md-3">
                                <label className="form-label">Customer GST</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="customerDetails.gstNumber"
                                    value={formData.customerDetails.gstNumber}
                                    onChange={handleFormChange}
                                    onBlur={handleBlur}
                                    disabled={isSelectFromList || pdfEdit}
                                />
                                {errors["customerDetails.gstNumber"] && (
                                    <div
                                        className="invalid-feedback d-block">{errors["customerDetails.gstNumber"]}</div>
                                )}
                            </div>

                            {/*Customer Address*/}
                            <div className="col-md-6">
                                <label className="form-label">Customer Address</label>
                                <textarea
                                    rows="2"
                                    className="form-control"
                                    name="customerDetails.address"
                                    value={formData.customerDetails.address}
                                    onChange={handleFormChange}
                                    onBlur={handleBlur}
                                    disabled={isSelectFromList || pdfEdit}
                                />
                            </div>
                        </div>
                    )}

                    <h5 className="mt-3">Item Details</h5>
                    <table className="table">
                        <thead>
                        <tr>
                            <th className="text-secondary fs-md">Product</th>
                            {formData.enableDisable.sacCode &&
                                <th className="text-secondary fs-md">SAC Code</th>
                            }
                            <th className="text-secondary fs-md">Quantity</th>
                            <th className="text-secondary fs-md">Unit Price</th>
                            {formData.enableDisable.gstPrint &&
                                <th className="text-secondary fs-md">Gst in %</th>
                            }
                            <th className="text-secondary fs-md">Total</th>
                            <th className="text-secondary fs-md"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {productsToBilled.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    {/* Product */}
                                    <input
                                        className="form-control"
                                        name="name"
                                        value={item.name}
                                        type="text"
                                        onBlur={() => handleProductBlur(index, "name")}
                                        onChange={(e) => handleProductChange(index, "name", e.target.value)}
                                    />
                                    {productErrors[index]?.name && (
                                        <div
                                            className="invalid-feedback d-block">{productErrors[index].name}</div>
                                    )}
                                </td>

                                {formData.enableDisable.sacCode &&
                                    <td style={{width: 150}}>
                                        {/* SAC code */}
                                        <input
                                            className="form-control"
                                            name="sacCode"
                                            value={item.sacCode}
                                            type="text"
                                            onBlur={() => handleProductBlur(index, "sacCode")}
                                            onChange={(e) => handleProductChange(index, "sacCode", e.target.value)}
                                        />
                                        {productErrors[index]?.sacCode && (
                                            <div
                                                className="invalid-feedback d-block">{productErrors[index].sacCode}</div>
                                        )}
                                    </td>
                                }

                                <td style={{width: 150}}>
                                    {/* Quantity */}
                                    <input
                                        className="form-control"
                                        name="quantity"
                                        value={item.quantity}
                                        type="text"
                                        onBlur={() => handleProductBlur(index, "quantity")}
                                        onChange={(e) => handleProductChange(index, "quantity", e.target.value)}
                                    />
                                    {productErrors[index]?.quantity && (
                                        <div
                                            className="invalid-feedback d-block">{productErrors[index].quantity}</div>
                                    )}
                                </td>
                                <td style={{width: 150}}>
                                    {/* Unit Price */}
                                    <input
                                        className="form-control"
                                        name="unitPrice"
                                        value={item.unitPrice}
                                        type="text"
                                        onBlur={() => handleProductBlur(index, "unitPrice")}
                                        onChange={(e) => handleProductChange(index, "unitPrice", e.target.value)}
                                    />
                                    {productErrors[index]?.unitPrice && (
                                        <div
                                            className="invalid-feedback d-block">{productErrors[index].unitPrice}</div>
                                    )}
                                </td>

                                {formData.enableDisable.gstPrint &&
                                    <td>
                                        {/* GST */}
                                        <SelectOption
                                            className="form-select"
                                            name="gst"
                                            id="gst"
                                            enums={true}
                                            value={item.gst}
                                            options={GSTType}
                                            onChange={(e) => {
                                                handleProductChange(index, "gst", e.target.value);
                                                validateProductRow({
                                                    ...productsToBilled[index],
                                                    gst: e.target.value
                                                }, index);
                                            }}
                                        />
                                        {productErrors[index]?.gst && (
                                            <div className="invalid-feedback d-block">{productErrors[index].gst}</div>
                                        )}
                                    </td>
                                }
                                <td style={{width: 200}}>
                                    {/* Total Price  */}
                                    <input
                                        className="form-control"
                                        name="total"
                                        type="text"
                                        value={item.total}
                                        disabled
                                    />
                                </td>

                                <td>
                                    {/* Add/Remove Buttons */}
                                    <div className="d-flex justify-content-start gap-2">
                                        <button className="btn btn-outline-success" type="button"
                                                onClick={handleAddRow}>
                                            +
                                        </button>
                                        {productsToBilled.length > 1 && (
                                            <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                onClick={() => handleRemoveRow(index)}
                                            >
                                                −
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {/*Totals*/}
                    <div className="ms-auto" style={{width: 400}}>
                        <div>
                            <div className="d-flex align-items-center justify-content-end mb-2">
                                <label className="form-label text-nowrap me-3 mb-0">Subtotal: </label>
                                <p className="m-0 fs-md mt-1 text-primary">₹ {subtotal}/-</p>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex align-items-center justify-content-end">
                                <label className="form-label text-nowrap me-3 mt-1">Discount</label>
                                <input
                                    id="totals.discount"
                                    type="text"
                                    placeholder="0"
                                    className="form-control text-danger"
                                    name="totals.discount"
                                    value={formData.totals.discount}
                                    // onBlur={handleBlur}
                                    onChange={handleFormChange}
                                    style={{width: "100px"}}
                                />
                            </div>
                        </div>

                        <div>
                            <div
                                className="d-flex align-items-center justify-content-end mb-2 border-top border-bottom pb-1 mt-3">
                                <p className="m-0 fs-md mt-1 text-primary">Grand Total: </p>
                                <p className="m-0 fs-md mt-1 text-primary">₹ {total.toFixed(2)}/-</p>
                            </div>
                        </div>

                        <div>
                            <div className="d-flex align-items-center justify-content-end mb-2">
                                <label className="form-label text-nowrap me-3 mt-1">Advance Payment</label>
                                <input
                                    id="totals.advancePaid"
                                    type="text"
                                    placeholder="0"
                                    className="form-control text-success"
                                    name="totals.advancePaid"
                                    value={formData.totals.advancePaid}
                                    // onBlur={handleBlur}
                                    onChange={handleFormChange}
                                    style={{width: "100px"}}
                                />
                            </div>
                        </div>
                        <div>
                            <div
                                className="d-flex align-items-center justify-content-end text-info mb-2 border-top border-bottom pb-1 mt-3">
                                <p className="m-0 fs-md mt-1">Remaining Amount: </p>
                                <p className="m-0 fs-md mt-1">₹ {remainingTotal.toFixed(2)}/-</p>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <button type="reset" className="btn bg-secondary bg-opacity-50 mt-4 me-3"
                                onClick={onResetHandler}>
                            Reset
                        </button>

                        <button
                            type="submit"
                            className="btn bg-primary bg-opacity-50 mt-4 "
                            disabled={createStatus === 'loading' || updateStatus === 'loading'}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
            }
        </>
    );
};

export default CreateInvoice;
